import {
  getServiceCallerList,
  getServiceCallerPatientList,
  reassignServiceCaller,
} from "../../services/ServiceCallerReassignmentService";
  
import {
  handleSuccess,
  showErrorAlert,
} from "../../services/ErrorHandlingService";

import {
  CONFIRMED_GET_SERVICE_CALLER_LIST,
  CONFIRMED_GET_PATIENTS_LIST,
  CONFIRMED_REASSIGN_PATIENTS,
} from "../actions/ServiceCallerReassignmentTypes";

// ACTION 1: Get service callers for dropdown
export function getServiceCallerListAction() {
  return async (dispatch) => {
    try {
      const response = await getServiceCallerList();
      if (response?.status === 200 && response.data?.status === "success") {
        dispatch({
          type: CONFIRMED_GET_SERVICE_CALLER_LIST,
          payload: response.data.data || [],
        });
        return { success: true, data: response.data.data };
      } else {
        showErrorAlert(response?.data?.message || "Failed to fetch service callers");
        return { success: false };
      }
    } catch (error) {
      console.error("Error:", error);
      showErrorAlert("Failed to fetch service callers");
      return { success: false };
    }
  };
}
  
// ACTION 2: Get patients by servicecaller_id
export function getPatientsListAction(servicecaller_id) {
  return async (dispatch) => {
    try {
      const response = await getServiceCallerPatientList(servicecaller_id);
      if (response?.status === 200 && response.data?.status === "success") {
        dispatch({
          type: CONFIRMED_GET_PATIENTS_LIST,
          payload: response.data.data || [],
        });
        return { success: true, data: response.data.data };
      } else {
        showErrorAlert(response?.data?.message || "Failed to fetch patients");
        return { success: false };
      }
    } catch (error) {
      console.error("Error:", error);
      showErrorAlert("Failed to fetch patients");
      return { success: false };
    }
  };
}
  
// ACTION 3: Reassign patients
export function reassignPatientsAction(admin_id, patient_ids, servicecaller_id) {
  return async (dispatch) => {
    try {
      const payload = {
     
        patient_id: Array.isArray(patient_ids)
        ? patient_ids.join("|")
        : patient_ids
        ? String(patient_ids)
        : "", // 🔥 FIX HERE
        servicecaller_id: servicecaller_id,
      };

      console.log("FINAL PAYLOAD 👉", payload); // debug

      const response = await reassignServiceCaller(payload);

      if (response?.status === 200 && response.data?.status === "success") {
        dispatch({
          type: CONFIRMED_REASSIGN_PATIENTS,
          payload: response.data,
        });
        handleSuccess(response.data?.message || "Patients reassigned successfully!");
        return { success: true };
      } else {
        showErrorAlert(response?.data?.message || "Failed to reassign patients");
        return { success: false };
      }
    } catch (error) {
      console.error("Error reassigning patients:", error);
      showErrorAlert("Failed to reassign patients");
      return { success: false };
    }
  };
}